import { Box, Paper, Typography, Avatar } from "@mui/material";
import Link from "@mui/material/Link";
import { useTranslation, Trans } from "react-i18next";
type ExternalLinkProps = {
  href: string;
  text: string;
  target?: string;
};
const ExternalLink = ({
  href,
  text,
  target = "_blank"
}: ExternalLinkProps) => {
  return <Typography component={Link} href={href} target={target} variant="body3" color="info.main" data-sentry-element="Typography" data-sentry-component="ExternalLink" data-sentry-source-file="DevResources.tsx">
      {text}
    </Typography>;
};
export const DevResources = () => {
  const {
    t
  } = useTranslation();
  return <Box data-cy="AllFilesDevResources" data-sentry-element="Box" data-sentry-component="DevResources" data-sentry-source-file="DevResources.tsx">
      <Typography variant="h5" mb="20px" color="common.white" data-sentry-element="Typography" data-sentry-source-file="DevResources.tsx">
        {t("code.developerResources")}
      </Typography>
      <Paper variant="outlined" elevation={0} sx={{
      p: "20px",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      backgroundColor: "transparent",
      color: "grey.400",
      borderColor: "grey.700",
      borderRadius: "8px"
    }} data-sentry-element="Paper" data-sentry-source-file="DevResources.tsx">
        <Typography variant="h6" color="common.white" data-sentry-element="Typography" data-sentry-source-file="DevResources.tsx">
          {t("code.buildFasterHeading")} 🚀
        </Typography>

        <Typography variant="body3" color="grey.400" data-sentry-element="Typography" data-sentry-source-file="DevResources.tsx">
          <Trans i18nKey="code.buildFasterBodyRich" components={{
          parsleyLink: <ExternalLink href="https://docs.zesty.io/docs/parsley" text="Parsley" />,
          replLink: <ExternalLink href="https://parsley.zesty.io/" text="REPL" />,
          docsLink: <ExternalLink href="https://docs.zesty.io/docs/parsley-index" text="documentation" />
        }} data-sentry-element="Trans" data-sentry-source-file="DevResources.tsx" />
        </Typography>

        <Typography variant="h6" color="common.white" data-sentry-element="Typography" data-sentry-source-file="DevResources.tsx">
          {t("code.simplifyWorkflowHeading")}
        </Typography>

        <Typography variant="body3" color="grey.400" data-sentry-element="Typography" data-sentry-source-file="DevResources.tsx">
          <Trans i18nKey="code.simplifyWorkflowBodyRich" components={{
          preprocessingLink: <ExternalLink href="https://docs.zesty.io/docs/css-js-processing-flow" text="CSS & JavaScript preprocessing" />
        }} data-sentry-element="Trans" data-sentry-source-file="DevResources.tsx" />
        </Typography>

        <Box display="flex" flexDirection="column" data-sentry-element="Box" data-sentry-source-file="DevResources.tsx">
          <Typography variant="h6" color="common.white" mb="8px" data-sentry-element="Typography" data-sentry-source-file="DevResources.tsx">
            {t("code.apiDocs")}
          </Typography>
          <Box component={Link} href="https://docs.zesty.io/reference/instances-api-reference" target="_blank" display="flex" flexDirection="row" alignItems="center" columnGap="12px" py="4px" height="36px" borderBottom="1px solid" borderColor="grey.700" sx={{
          textDecoration: "none!important"
        }} data-sentry-element="Box" data-sentry-source-file="DevResources.tsx">
            <Avatar src="/images/postmanIcon.svg" sx={{
            width: 24,
            height: 24
          }} data-sentry-element="Avatar" data-sentry-source-file="DevResources.tsx" />
            <Typography variant="body2" color="common.white" data-sentry-element="Typography" data-sentry-source-file="DevResources.tsx">
              {t("common.instanceApiDocs")}
            </Typography>
          </Box>
          <Box component={Link} href="https://docs.zesty.io/docs/graphql#GraphQL" target="_blank" display="flex" flexDirection="row" alignItems="center" columnGap="12px" py="4px" height="36px" borderBottom="1px solid" borderColor="grey.700" sx={{
          textDecoration: "none!important"
        }} data-sentry-element="Box" data-sentry-source-file="DevResources.tsx">
            <Avatar src="/images/graphQLIcon.svg" sx={{
            width: 24,
            height: 24
          }} data-sentry-element="Avatar" data-sentry-source-file="DevResources.tsx" />
            <Typography variant="body2" color="common.white" data-sentry-element="Typography" data-sentry-source-file="DevResources.tsx">
              {t("common.graphqlDocs")}
            </Typography>
          </Box>
          <Box component={Link} href="https://docs.zesty.io/docs/parsley" target="_blank" display="flex" flexDirection="row" alignItems="center" columnGap="12px" py="4px" height="36px" borderBottom="1px solid" borderColor="grey.700" sx={{
          textDecoration: "none!important"
        }} data-sentry-element="Box" data-sentry-source-file="DevResources.tsx">
            <Avatar src="/images/parsleyIcon.svg" sx={{
            width: 24,
            height: 24
          }} data-sentry-element="Avatar" data-sentry-source-file="DevResources.tsx" />
            <Typography variant="body2" color="common.white" data-sentry-element="Typography" data-sentry-source-file="DevResources.tsx">
              {t("common.parsleyDocs")}
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>;
};